import { clone } from '@jack-henry/frontend-utils/functions';
import { RemoteDepositProductModelDto } from '@treasury/api/bo';
import { CompanyProductFeature } from './company-product-feature.entity';

const defaultDto: RemoteDepositProductModelDto = {
    id: 0,
    productUniqueId: '',
    type: 'RemoteDeposits',
    remoteDepositProductTypeId: 0,
    isConfigurable: true,
};
export class RemoteDepositCaptureProductFeature extends CompanyProductFeature<RemoteDepositProductModelDto> {
    constructor(dto: RemoteDepositProductModelDto = clone(defaultDto)) {
        super(dto);
    }

    public get customerId() {
        return this.dto.ssoCustomerId ?? '';
    }

    public set customerId(value: string) {
        this.dto.ssoCustomerId = value;
    }

    public get name() {
        return 'Remote deposit capture (RDC)';
    }
}
